module.exports = __webpack_public_path__ + "static/media/circle-background.299ac53e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/featured-cards/circle-background.png
// module id = 2274
// module chunks = 0